import React, { useState } from 'react';
import type { ReactNode } from 'react';

import Icon from '@wetransfer/transfer/component/icon';
import I18n from '@wetransfer/transfer/modules/i18n';

import { MESSAGE_CUTOFF_POINT } from './constants';
import { MessageProps } from './types';

export const Message: React.FC<MessageProps> = ({ content }) => {
  const [isTextExpanded, setIsTextExpanded] = useState(false);

  let expandButton: ReactNode | null = null;
  const messageClassNames = ['downloader__message'];
  let textMessage = content;
  const onExpandText = () => setIsTextExpanded(true);

  // Cut it off.
  if (content.length < MESSAGE_CUTOFF_POINT || isTextExpanded) {
    messageClassNames.push('downloader__message--expanded');
  } else if (content.length >= MESSAGE_CUTOFF_POINT) {
    textMessage = `${textMessage.substr(0, MESSAGE_CUTOFF_POINT)} ...`;
    expandButton = (
      <span
        className="downloader__expand-msg"
        onClick={onExpandText}
        data-testid="message_expandButton"
      >
        {I18n.t('transfer.download.expand')}
        <Icon type="Arrow" orientation="bottom" />
      </span>
    );
  }

  return (
    <div
      className={messageClassNames.join(' ')}
      data-testid="expandableMessage"
    >
      <p>
        {textMessage}
        {expandButton}
      </p>
    </div>
  );
};
